import { Link } from "react-router-dom";
import { getFeaturedProducts } from "@/utils/content";

export default function FeaturedProducts() {
  const products = getFeaturedProducts(4);

  return (
    <section className="max-w-site mx-auto px-4 md:px-6 py-14 md:py-20">
      <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-10">
        <div>
          <p className="text-xs md:text-sm font-medium tracking-[0.3em] text-accent-700 mb-3">
            FEATURED
          </p>
          <h2 className="text-2xl md:text-3xl font-semibold text-foreground-950 font-heading">
            推荐产品
          </h2>
        </div>
        <Link
          to="/products"
          className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
        >
          浏览全部产品
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div data-product-shop className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
        {products.map((item) => (
          <Link
            key={item.id}
            to={`/detail/${item.id}`}
            className="group flex flex-col bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-primary-300 transition-colors cursor-pointer h-full"
          >
            <div className="w-full aspect-square overflow-hidden bg-background-100">
              <img
                src={item.cover}
                alt={item.title}
                title={`${item.title} - 白峰美羽`}
                className="w-full h-full object-cover object-top group-hover:scale-[1.05] transition-transform duration-500"
              />
            </div>
            <div className="p-4 flex flex-col flex-1">
              <span className="text-[11px] text-accent-700 mb-1.5">{item.category}</span>
              <h3 className="text-sm md:text-base font-medium text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                {item.title}
              </h3>
              <p className="mt-1.5 text-xs text-foreground-500 leading-relaxed line-clamp-2">
                {item.summary}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}